import { useEffect, useState } from "react";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;

export function useGoogleMapsLoader(libraries: string[] = ["drawing", "places", "marker"]): boolean {
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const handleError = (event: ErrorEvent) => {
            if (
                event.message?.includes("can't access property") &&
                event.filename?.includes("maps.googleapis.com")
            ) {
                event.preventDefault();
                return true;
            }
        };

        const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
            if (
                event.reason?.message?.includes("maps.googleapis.com") ||
                event.reason?.stack?.includes("maps.googleapis.com")
            ) {
                event.preventDefault();
            }
        };

        window.addEventListener("error", handleError);
        window.addEventListener("unhandledrejection", handleUnhandledRejection);

        if ((window as any).google?.maps?.Map) {
            setTimeout(() => setLoaded(true), 100);
            return () => {
                window.removeEventListener("error", handleError);
                window.removeEventListener("unhandledrejection", handleUnhandledRejection);
            };
        }

        const librariesParam = libraries.join(",");
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.64&libraries=${librariesParam}`;
        script.async = true;
        script.onload = () => {
            setTimeout(() => {
                if ((window as any).google?.maps?.Map) {
                    setLoaded(true);
                }
            }, 200);
        };
        script.onerror = () => {
            console.error("Failed to load Google Maps");
        };
        document.head.appendChild(script);

        return () => {
            window.removeEventListener("error", handleError);
            window.removeEventListener("unhandledrejection", handleUnhandledRejection);
        };
    }, []); // run once on mount

    return loaded;
}
